import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import { extend } from 'flarum/common/extend';
export { default as extend } from './extend';
app.initializers.add('fof-seo', () => {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!app.forum.attribute('canConfigureSeo')) return;
    items.add('manageSeo', m(Button, {
      icon: "fas fa-search",
      onclick: () => app.modal.show(() => import(/* webpackChunkName: 'common/Components/MetaSeoModal', webpackMode: 'lazy-once' */ '../common/Components/MetaSeoModal'), {
        objectType: 'discussions',
        objectId: discussion.id()
      })
    }, app.translator.trans('fof-seo.forum.controls.configure_seo')), -1000);
  });
});flarum.reg.addChunkModule('891', '933', 'fof-seo', 'common/Components/MetaSeoModal');
flarum.reg.addChunkModule('891', '933', 'fof-seo', 'admin/utils/countKeywords');